import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Benign browser quirk (often MUI useMediaQuery) — CRA dev overlay treats it as fatal.
const resizeObserverLoopPattern =
  /^ResizeObserver loop (completed with undelivered notifications\.|limit exceeded)$/;

window.addEventListener('error', (event) => {
  if (resizeObserverLoopPattern.test(event.message)) {
    event.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
